import { updateClasses } from './middlewares/settings.middleware.js';
import { updateTheme } from './middlewares/themes.middleware.js';
import { reconcileZooSliceWithProfile } from '../utils/users/activeParkSwitch';

const STORAGE_KEY = 'angle-store-key';

/**
 * Use this function if you need to call a middleware
 * when setting the initial state.
 */
const callMiddlewares = state => {
    // Since a middlwrare is requried to modify the DOM in this case
    // for settings and themes, is necessary to call middleware
    // directly to set the initial state loaded from storage

    updateClasses(state);
    updateTheme(state)
}

/* Use an IIFE to export the persisted state in a variable */
export const persistedState = (() => {
    try {
        const rawState = localStorage.getItem(STORAGE_KEY);
        if (rawState === null) return undefined;
        const state = JSON.parse(rawState);
        if (state.zoo) state.zoo = { ...state.zoo, zooOptions: {}, productScopeReady: false, productScopeSelectionPending: false, productScopeSelectionRevision: 0 };
        // Parc actif (étape 4) : un autre onglet a pu réécrire cette tranche avec
        // un autre parc autour d'une bascule ; la copie du profil fait foi.
        try {
            state.zoo = reconcileZooSliceWithProfile(state.zoo, JSON.parse(localStorage.getItem('userData') || 'null'));
        } catch (_error) { /* copie illisible : tranche gardée */ }
        callMiddlewares(state);


        console.log("state dans call persisted")
        console.log(state)
        return state;
    } catch (err) {
        console.log(err);
        return undefined;
    }
})();

/* Export a method to save state on each store update */
export const saveState = (state) => {
    try {
        let stateFilter = JSON.parse(JSON.stringify(state)); // deep clone

        ['offsidebarOpen', 'asideToggled', 'horizontal', 'helpDrawerOpen'] // states which we don't want to persist.
            .forEach(item => delete stateFilter.settings[item])
        if (stateFilter.zoo) stateFilter.zoo = { ...stateFilter.zoo, zooOptions: {}, productScopeReady: false, productScopeSelectionPending: false, productScopeSelectionRevision: 0 };
        const rawState = JSON.stringify(stateFilter);
        localStorage.setItem(STORAGE_KEY, rawState);
    } catch (err) {
        console.log(err);
    }
};